import { render } from "./ChatAdvisorPopup.vue?vue&type=template&id=cb237270"
import script from "./ChatAdvisorPopup.vue?vue&type=script&lang=js"
export * from "./ChatAdvisorPopup.vue?vue&type=script&lang=js"

import exportComponent from "/home/deployuser/staging/immivo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__